import { BomItem } from '../../resources/designItem/bomItemFrontendTypes';
import { ModuleTableData } from '../Bom/components/ModuleTableData';

/**
 * Tests if the given BOM item is empty meaning it's in the "new BOM item" state.
 */
export function isEmptyBomItem(mod: ModuleTableData | BomItem) {
    return mod.id.length === 0;
}
